import React, { useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import ExpandCircleDownOutlinedIcon from "@mui/icons-material/ExpandCircleDownOutlined";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { useState } from "react";
import { getTickerList } from "layouts/applications/data-tables/data/getData";
import { Card, Checkbox, CircularProgress, Grid, Icon, IconButton, List, ListItem, createTheme } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DoneIcon from "@mui/icons-material/Done";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";
import { getOptionCallData } from "layouts/applications/data-tables/data/getData";
import { upperCase } from "lodash";
import SoftBox from "components/SoftBox";
import HeaderWelcomeMessage from "components/etc/HeaderWelcomeMessage";
import FacebookIcon from "@mui/icons-material/Facebook";
import GoogleIcon from "@mui/icons-material/Google";
import SoftTypography from "components/SoftTypography";
import useAuth from "layouts/authentication/hooks/useAuth";
import Separator from "layouts/authentication/components/Separator";
import { ThemeProvider } from "@emotion/react";
import { useSoftUIController } from "context";
import { setLayout } from "context";
import axios from "layouts/authentication/api/axios";
import MuiLink from "@mui/material/Link";
import Popup from "layouts/applications/popup/Popup";
import { updateStockData } from "layouts/applications/data-tables/data/getData";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { roundToTwo } from "layouts/Helper/helper";

const BackToButton = (text) => {
  return null;

  const navigate = useNavigate();
  return (
    <div className="backDiv">
      <div
        onClick={() => {
          navigate(text.destination);
        }}
        className="innerBackDiv"
      >
        <p unselectable="on" className="inline backText">
          {text.text}
        </p>
        <ExpandCircleDownOutlinedIcon className="expandIcon" />
      </div>
    </div>
  );
};

export default BackToButton;

export function TLSText({ value, green, yellow, red, higherBetter }) {
  const { auth } = useAuth();

  let colour = "black";

  if (!value || isNaN(value)) return (
    <p className={`inline helvetica`} style={{ fontSize: "14px", color: colour }}>
      -
    </p>
  )

  // only show colors if user is logged in
  if (auth && auth.email) {
    // if (higherBetter) {
    //   if (value >= yellow) {
    //     colour = "#FFBB33";
    //   } else if (value >= green) {
    //     colour = "green";
    //   } else if (value <= red) {
    //     colour = "red";
    //   }
    // } else {
    //   if (value <= yellow) {
    //     colour = "#FFBB33";
    //   } else if (value <= green) {
    //     colour = "green";
    //   } else if (value >= red) {
    //     colour = "red";
    //   }
    // }
    if (green)
      colour = "green";
    else if (yellow)
      colour = "#FFBB33";
    else if (red)
      colour = "red";
  }

  return (
    <p className={`inline helvetica`} style={{ fontSize: "14px", color: colour }}>
      {value < 0 ? value : roundToTwo(Math.abs(value))}
    </p>
  );
}

export function RightSideNavBar({
  isMini,
  navbarRow,
  inputText,
  light,
  handleMiniSidenav,
  navbarIconButton,
  miniSidenav,
  handleConfiguratorOpen,
  setInputText,
  handleOpenMenu,
  renderMenu,
}) {
  const { auth, logoutUser } = useAuth();

  const location = useLocation();
  const navigate = useNavigate();

  const handleLogout = () => {
    logoutUser();
  };

  const handleLogin = () => {
    navigate("/dashboard/authentication/sign-in", { state: { from: location } });
  };

  const handleProfileClick = () => {
    navigate("/dashboard/pages/account/settings");
  };
  return (
    <div style={{ marginLeft: "3px" }}>
      {isMini ? null : (
        <SoftBox sx={(theme) => navbarRow(theme, { isMini })}>
          <SoftBox pr={1} className=" searchSymbolInputDiv">
            <SearchSymbolInput
              goToFundamental={true}
              inputText={inputText}
              setInputText={setInputText}
            ></SearchSymbolInput>
          </SoftBox>
          <SoftBox color={light ? "white" : "inherit"} className="iconsDivDesktop navbarBox">
            <SoftBox>
              <SoftBox
                sx={{ ...navbarIconButton, display: "flex", alignItems: "center", gap: "5px" }}
                size="small"
                className="headerWelcomeMessageDesktop"
              >
                <SoftTypography variant="button" fontWeight="medium" color={light ? "white" : "dark"}>
                  Welcome {auth?.first_name ? auth.first_name : auth?.email ? auth.email : "Guest!"}
                </SoftTypography>
                <SoftTypography
                  variant="button"
                  fontWeight="medium"
                  color={light ? "white" : "dark"}
                  onClick={auth?.email ? handleLogout : handleLogin}
                >
                  | {auth?.email ? "Sign Out" : "Sign In"}
                </SoftTypography>
              </SoftBox>
            </SoftBox>
            <div className="navbarIcons" style={{ display: "flex", justifyContent: "flex-end" }}>
              <IconButton
                size="small"
                color="inherit"
                sx={navbarIconButton}
                onClick={handleProfileClick}
                style={{ marginLeft: "-9px" }}
              >
                <Icon>account_circle</Icon>
              </IconButton>
              <IconButton size="small" color="inherit" onClick={handleMiniSidenav}>
                <Icon fontSize="32px" className={light ? "standard_icon text-white" : "text-dark "}>
                  {miniSidenav ? "menu_open" : "menu"}
                </Icon>
              </IconButton>
              <IconButton size="small" color="inherit" sx={navbarIconButton} onClick={handleConfiguratorOpen}>
                <Icon>settings</Icon>
              </IconButton>
              {/* <IconButton
								size="small"
								color="inherit"
								sx={navbarIconButton}
								aria-controls="notification-menu"
								aria-haspopup="true"
								variant="contained"
								onClick={handleOpenMenu}
							>
								<Icon className={light ? "text-white" : "text-dark"}>notifications</Icon>
							</IconButton> */}
            </div>
            {renderMenu()}
          </SoftBox>
        </SoftBox>
      )}
      <SoftBox className="iconsDivMobile" color={light ? "white" : "inherit"}>
        <SoftBox sx={{ ...navbarIconButton, display: "flex", alignItems: "center", gap: "5px" }}>
          <SoftTypography variant="button" fontWeight="medium" color={light ? "white" : "dark"}>
            Welcome {auth?.first_name ? auth.first_name : auth?.email ? auth.email : "Guest!"}
          </SoftTypography>
          <SoftTypography
            variant="button"
            fontWeight="medium"
            color={light ? "white" : "dark"}
            onClick={auth?.email ? handleLogout : handleLogin}
          >
            | {auth?.email ? "Sign Out" : "Sign In"}
          </SoftTypography>
        </SoftBox>
        <IconButton
          size="small"
          color="inherit"
          sx={navbarIconButton}
          onClick={handleProfileClick}
          style={{ marginLeft: "-9px" }}
        >
          <Icon>account_circle</Icon>
        </IconButton>
        <IconButton size="small" color="inherit" onClick={handleMiniSidenav}>
          <Icon fontSize="32px" className={light ? "text-white standard_icon" : "standard_icon text-dark"}>
            {miniSidenav ? "menu_open" : "menu"}
          </Icon>
        </IconButton>
        <IconButton size="small" color="inherit" sx={navbarIconButton} onClick={handleConfiguratorOpen}>
          <Icon>settings</Icon>
        </IconButton>
        {/* <IconButton
          size="small"
          color="inherit"
          sx={navbarIconButton}
          aria-controls="notification-menu"
          aria-haspopup="true"
          variant="contained"
          onClick={handleOpenMenu}
        >
          <Icon className={light ? "text-white" : "text-dark"}>notifications</Icon>
        </IconButton> */}

        {renderMenu()}
      </SoftBox>
    </div>
  );
}

export function TLSGEMColour(value, green, yellow) {
  let colour = "black";
  //if (!value) return colour;
  
  if (value <= green) {
    colour = "green";
  } else if (value <= yellow) {
    colour = "#FFBB33";
  } else {
    colour = "red";
  }

  return colour;
}

export function ScrollToTopButton() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        console.log("is visible");
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);

    return () => {
      window.removeEventListener("scroll", toggleVisibility);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div>
      {isVisible ? (
        <KeyboardArrowUpIcon
          fontSize="large"
          className="scroll-to-top-button "
          onClick={scrollToTop}
        ></KeyboardArrowUpIcon>
      ) : (
        <div></div>
      )}
    </div>
  );
}

export const SignUpCard = ({ headerText, paraText, setPaymentPopup }) => {
  const [controller, dispatch] = useSoftUIController();
  const ListOfHeaders = [
    "Definitions",
    "Licence",
    "Restricted access",
    "Registered Users & Subscribers",
    "Third Party Content",
    "Our warranties",
    "Indemnity",
    "Financial disclaimer",
    "General disclaimer",
    "Third party websites",
    "Trade marks",
    "Term & Termination",
    "Subscription Trial Period",
    "Charges",
    "Refund / Cancellation",
    "General",
    "Conduct website behaviour and the support service",
    "Information",
  ];
  const theme = createTheme({
    palette: {
      primary: {
        main: "#0E6620", // Green color
      },
    },
  });
  const { setUserSession } = useAuth();
  const navigate = useNavigate();

  // const { pathname } = useLocation();
  const [errorMessage, setErrorMessage] = useState("");

  const [agreement, setAgremment] = useState(false);

  const handleSetAgremment = () => setAgremment(!agreement);

  const [disclaimer, setDisclaimer] = useState(false);

  const handleSetDisclaimer = () => setDisclaimer(!disclaimer);

  const [inputText, setInputText] = useState({ email: "", password: "", name: "" });

  const [popup, togglePopup] = useState(false);
  function handleChange(event) {
    const name = event.target.name;
    const value = event.target.value;
    setInputText((prevValue) => {
      if (name === "email") {
        return {
          email: value,
          password: prevValue.password,
          name: prevValue.name,
        };
      } else if (name === "name") {
        return {
          email: prevValue.email,
          password: prevValue.password,
          name: value,
        };
      } else {
        //if name === password
        return {
          email: prevValue.email,
          password: value,
          name: prevValue.name,
        };
      }
    });
  }
  const validate = (values) => {
    const errors = {};

    if (values.password === "") {
      errors.password = "Password is required";
    }
    if (values.name === "") {
      errors.name = "Name is required";
    }
    if (values.email === "") {
      errors.email = "Email is required";
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
      //regex for email validation
      errors.email = "Invalid email address";
    }
    if (!agreement) {
      //terms and conditions button
      errors.agreement = "Terms and Conditions is not ticked";
    }

    if (!disclaimer) {
      errors.disclaimer = "Disclaimer is not ticked";
    }
    return errors;
  };
  function submiteNote(e) {
    e.preventDefault();
    const error = validate(inputText);
    if (!error.email && !error.password && !error.name && !error.agreement && !error.disclaimer) {
      setErrorMessage("");
      registerUser(inputText);
    } else {
      if (error.name) {
        setErrorMessage(error.name);
      } else if (error.email) {
        setErrorMessage(error.email);
      } else if (error.password) {
        setErrorMessage(error.password);
      } else if (error.agreement) {
        setErrorMessage(error.agreement);
      } else {
        setErrorMessage(error.disclaimer);
      }
    }
  }
  const registerUser = async (user) => {
    try {
      const res = await axios().post(
        "/auth/signup",
        {
          email: user.email,
          password: user.password,
          name: user.name,
        },
        { withCredentials: true }
      );
      if (res.data?.access_token) {
        const access_token = res.data.access_token;
        await setUserSession({
          first_name: user.first_name,
          email: user.email,
          access_token: access_token,
          role: res.data.role ? res.data.role : "user",
          email_verified: res.data.email_verified,
          created_at: res.data.created_at,
          plan: res.data.plan,
        });
        setErrorMessage("");
        setInputText({ email: "", password: "", name: "" });
        const redirectTo = localStorage.getItem("redirectAfterLogin");
        setPaymentPopup(dispatch, { on: false });
        if (redirectTo) {
          localStorage.removeItem("redirectAfterLogin");
          navigate(redirectTo, { replace: true });
        } else navigate("/dashboard", { replace: true });
      } else {
        //show error to user
        setErrorMessage("Sorry! An unexpected error occurred. Please try again later.");
        console.log(res);
      }
    } catch (error) {
      if (error.response?.data?.detail) setErrorMessage(error.response.data.detail);
      else setErrorMessage("Sorry! An unexpected error occurred. Please try again later.");
      console.log(error);
    }
  };

  return (
    <Grid className="outer" item lg={6} md={12} sm={12} xs={12}>
      <Card className="signInPopupCard popupWidth">
        <SoftBox className="cardMargin bbvColour" borderRadius="lg" mx={2} p={2} mb={2} textAlign="center">
          <SoftBox p={2} textAlign="center">
            <SoftTypography className="roboto" variant="h5" fontWeight="medium" color="white">
              {headerText}
            </SoftTypography>
            <SoftTypography
              className="roboto_medium"
              style={{ fontSize: "14px", marginTop: "10px" }}
              fontWeight="light"
              color="white"
            >
              {paraText}
            </SoftTypography>
          </SoftBox>
          <Grid container spacing={3} justifyContent="center" sx={{ mb: 2 }}>
            <Grid item xs={2}>
              <SoftTypography component={MuiLink} href="#" variant="body1" color="white">
                <FacebookIcon className="icon" color="inherit" />
              </SoftTypography>
            </Grid>
            <Grid item xs={2}>
              <SoftTypography component={MuiLink} href="#" variant="body1" color="white">
                <GoogleIcon className="icon" color="inherit" />
              </SoftTypography>
            </Grid>
          </Grid>
        </SoftBox>
        <Separator />
        <SoftBox p={2} px={3}>
          <SoftBox component="form" role="form">
            <SoftBox mb={2}>
              <SoftInput name="name" onChange={handleChange} placeholder="Name" value={inputText.name} />
            </SoftBox>
            <SoftBox mb={2}>
              <SoftInput
                name="email"
                type="email"
                onChange={handleChange}
                placeholder="Email"
                value={inputText.email}
              />
            </SoftBox>
            <SoftBox mb={2}>
              <SoftInput
                name="password"
                type="password"
                onChange={handleChange}
                placeholder="Password"
                value={inputText.password}
              />
            </SoftBox>
            <SoftBox display="flex" alignItems="center">
              <ThemeProvider theme={theme}>
                <Checkbox checked={agreement} onChange={handleSetAgremment} className="checkbox" />
              </ThemeProvider>
              <SoftTypography
                variant="button"
                fontWeight="regular"
                onClick={handleSetAgremment}
                sx={{ cursor: "pointer", userSelect: "none" }}
                className="termsAndConditions"
              >
                I agree to the&nbsp;
              </SoftTypography>
              <p
                onClick={() => {
                  togglePopup(!popup);
                }}
                fontWeight="bold"
                className="termsAndConditions underline roboto"
              >
                Terms and Conditions
              </p>
            </SoftBox>
            <SoftBox style={{ marginTop: "8px" }} display="flex" alignItems="">
              <ThemeProvider theme={theme}>
                <Checkbox checked={disclaimer} onChange={handleSetDisclaimer} className="checkbox" />
              </ThemeProvider>
              {/* <Checkbox checked={disclaimer} onChange={handleSetDisclaimer} /> */}
              <SoftTypography
                variant="button"
                fontWeight="regular"
                onClick={handleSetDisclaimer}
                sx={{ cursor: "pointer", userSelect: "none" }}
                className="termsAndConditions"
                style={{ marginTop: "5px" }}
              >
                I understand that all data are solely for information purposes and should not be considered as financial
                advice.
              </SoftTypography>
            </SoftBox>
            <SoftBox mt={4} mb={1}>
              <SoftButton onClick={submiteNote} className="bbvGreen" variant="gradient" color="dark" fullWidth>
                sign up
              </SoftButton>
            </SoftBox>
            {errorMessage && <div className="error"> {errorMessage} </div>}
            <SoftBox mt={3} textAlign="center">
              <SoftTypography variant="button" color="text" fontWeight="regular">
                Already have an account?&nbsp;
                <SoftTypography
                  component={Link}
                  to="/dashboard/authentication/sign-in"
                  variant="button"
                  color="dark"
                  fontWeight="bold"
                >
                  Sign in
                </SoftTypography>
              </SoftTypography>
            </SoftBox>
          </SoftBox>
        </SoftBox>
      </Card>
      {popup ? (
        <Popup transparent={false}>
          <CloseIcon
            className="close-btn icon"
            onClick={() => {
              togglePopup(!popup);
            }}
          />
          <div style={{ marginTop: "30px" }}>
            <SoftBox
              style={{ marginTop: "20px", maxHeight: "600px", overflowY: "auto" }}
              p={3}
              mt={3}
              mb={20}
              className="tnc"
            >
              <SoftTypography>
                <strong style={{ fontSize: "18px" }} className="roboto">
                  These Terms of Service were last updated on 20 April 2023.
                </strong>
              </SoftTypography>
              <ul style={{}}>
                {ListOfHeaders.map((header, index) => {
                  return (
                    <li style={{ fontSize: "18px" }} className="roboto" key={index}>
                      {index + 1}. {header}
                    </li>
                  );
                })}
              </ul>

              <SoftTypography>
                <strong>(1) Definitions</strong>
                <br />
                In these Terms:
              </SoftTypography>

              <SoftTypography>
                &ldquo;Charges&rdquo; means the subscription charges payable to BullBearVector by the Subscriber in
                respect of the Subscription Services;
              </SoftTypography>

              <SoftTypography>
                &quot;Content Guidelines&quot; means the &#39;forum guidelines&#39;, &#39;posting guidelines&#39;,
                &#39;article guidelines&#39; and &#39;editing guidelines&#39; and &#39;basic etiquette guidelines&#39;
                posted on our Website as amended by us from time to time;
              </SoftTypography>

              <SoftTypography>
                &quot;Intellectual Property Rights&quot; means all intellectual property rights wherever in the world
                arising, whether registered or unregistered, and including any application or right of application for
                such rights (including without limitation copyright and related rights, moral rights, registered and
                unregistered trademarks, patents, design rights and database rights);
              </SoftTypography>

              <SoftTypography>
                &quot;Registered User&quot; means a person who has created an account with the Website;
              </SoftTypography>

              <SoftTypography>
                &quot;BullBearVector Content&quot; means financial news articles, blogs and other textual content that
                we write and publish for free on the Website, identified by being authored by either BullBearVector
                News, BullBearVector Features or our staff;
              </SoftTypography>

              <SoftTypography>
                &ldquo;Subscription Service&rdquo; means one of the paid-for data and screening subscription services
                (&ldquo;BullBearVector Data&rdquo;) and data analysis tools available on the Website from time to time,
                including but not limited to the BullBearVector Premium services;
              </SoftTypography>

              <SoftTypography>
                &ldquo;Subscriber&rdquo; means a Registered User who has subscribed to a Subscription Service;
              </SoftTypography>

              <SoftTypography>
                &ldquo;Third Party Content&rdquo; means financial news, articles, advertising and/or other content
                (including without limitation video, textual, graphic, photographic, audio and audio-visual content)
                that is published on the Website, but is provided by third parties (for example content sourced from
                external publishers including news organisations and research houses),
                <br />
                &ldquo;BullBearVector Data&rdquo; means data that we source from third party data suppliers and any
                intermediate algorithms and calculations that we undertake in respect of that data;
              </SoftTypography>

              <SoftTypography>
                &quot;Trial Period&quot; means a period during which the Subscriber can access a Subscription Service
                without paying the Charges;
              </SoftTypography>

              <SoftTypography>
                &quot;Use&quot; means any use whatsoever and includes, without limitation, viewing, storing,
                reproducing, displaying, publishing, distributing, broadcasting and/or creating derivative works;
              </SoftTypography>

              <SoftTypography>
                &quot;User Content&quot; means content (including without limitation video, textual, graphic,
                photographic, audio and audio-visual content) uploaded or otherwise provided for publication by a
                Registered User for Use on or in relation to the Website; and
              </SoftTypography>

              <SoftTypography>
                &quot;Website&quot; means the website at https://bullbearvector.com/ or any successor site operated by
                us from time to time.
              </SoftTypography>

              <SoftTypography>
                References in these Terms to &quot;we&quot; or &quot;us&quot; mean Core Biz Holdings Pte. Ltd;. and
                references in these Terms to &quot;you&quot; mean the person using the Website or holding a Registered
                User account with the Website.
              </SoftTypography>

              <SoftTypography>
                <strong>(2) Licence</strong>
                <br />
                We or our licensors own the Intellectual Property Rights in the Website and material on the Website. You
                may view, download for caching purposes only, and print material from the Website, in each case for
                personal use only, and subject to the restrictions set out below. Non-personal use is a violation of
                these Terms. Save to the extent that you own (or are properly licensed by a third party to exercise) the
                relevant rights, you must not: (a) republish or redistribute material from the Website (including
                republication or redistribution on another website or in any other format); (b) sell, rent or
                sub-license material from the Website; (c) edit or otherwise modify any material from the Website except
                in accordance with the Content Guidelines; (d) make any charge in relation to or carry on by way of
                business any activities in relation to any material obtained from the Website; or (e) show (whether for
                commercial purposes or not) any material from the Website in public. You must not use any material from
                the Website for any improper or unlawful purpose or conduct any scraping, data mining or automated data
                collection in relation to the Website. You must not use the Website in any way that causes, or may
                cause, damage to the Website or impairment of the availability or accessibility of the Website, or in
                any way which is unlawful, illegal, fraudulent or harmful, or in connection with any unlawful, illegal,
                fraudulent or harmful purpose or activity.
              </SoftTypography>

              <SoftTypography>
                <strong>(3) Restricted access</strong>
                <br />
                Access to certain areas of the Website is restricted to Registered Users and may be further restricted
                to Subscribers. We reserve the right to restrict access to other areas of the Website, or indeed the
                whole Website, at our discretion. You must not use the login details or password of any other person to
                access restricted areas of the Website.
              </SoftTypography>

              <SoftTypography>
                <strong>(4) Registered Users &amp; Subscribers</strong>
                <br />
                In order to become a Registered User, you must create an account using the Website interface, and click
                on the activation link in the email that we will send to you. Registered Users gain access to additional
                services and restricted areas on the Website, which may include: (i) the ability to submit and edit
                articles on the Website; (ii) the ability to subscribe to RSS/Atom feeds; (iii) the ability to submit
                posts to our Website forums and to rate others&#39; posts; (iv) access to our virtual fund trading
                facility; (v) the facility to create a detailed profile which may be made available via the Website;
                (vi) access to our Website-based messaging system; (vii) in the case of Subscribers only, access to the
                Subscription Service
              </SoftTypography>

              <SoftTypography>
                Registered Users must not allow any other person to use their user ID and password, and they must ensure
                that that user ID and password are kept confidential. Registered Users accept responsibility for all
                activities that occur under or in relation to their user ID and password. Upon our request, Registered
                Users and will provide to us proof of their identity and/or age.
                <br />
                We may also be required by law or regulation to identify Registered Users and disclose their details to
                a third party including the relevant legal or regulatory authority if requested by them to do so.
              </SoftTypography>

              <SoftTypography>
                We may alter or restrict the services and areas that Registered Users have access to, and/or delete any
                Registered User&#39;s account, in our sole discretion without notice or explanation.
              </SoftTypography>

              <SoftTypography>
                <strong>(5) Third Party Content</strong>
                <br />
                Subject to the BullBearVector Data warranties in Section 7 below, we do not undertake to monitor Third
                Party Content that appears on the Website. Nor do we warrant that Third Party Content providers have
                adhered to these Terms, although we use reasonable endeavours to remove Third Party Content which
                breaches these Terms after it has been brought to our attention. If you become aware of any Third Party
                Content on the Website which breaches these Terms, you should notify us of that content immediately.
              </SoftTypography>

              <SoftTypography>
                <strong>(6) Our warranties</strong>
                <br />
                You acknowledge that the Website and the material on the Website may be changed from time to time
                without notice. As we provide BullBearVector Content as a free service to all our users, we offer no
                warranties in respect of the preparation and publication of this content.
              </SoftTypography>

              <SoftTypography>
                Subject to the warranty given above in respect of the paid-for Subscription Service:
                <br />
                (a) we do not warrant the completeness, veracity, bona fides or accuracy of the material on the Website;
                nor do we commit to ensuring that the Website remains available or that the material on the Website is
                kept up-to-date;
                <br />
                (b) we do not grant to you any warranties or make any representations relating to the Website or your
                Use of the Website, and to the fullest extent permitted by applicable law we exclude all warranties and
                representations.
              </SoftTypography>

              <SoftTypography>
                You acknowledge that the material on the Website submitted by third parties (including our Registered
                Users) from time to time is the sole responsible of the third party who has submitted that material. If
                you become aware of any inaccuracy or error on the website, please let us know.
              </SoftTypography>

              <SoftTypography>
                <strong>(7) Indemnity</strong>
                <br />
                You will indemnify us and keep us indemnified against any loss, damage, expense, cost or liability
                incurred or suffered by us arising out of any breach by you of any of these Terms, or arising out of any
                claim that you have breached any of these Terms.
              </SoftTypography>

              <SoftTypography>
                <strong>(8) Financial disclaimer</strong>
                <br />
                Our Website is a financial data and news portal, discussion forum and content aggregator. BullBearVector
                is not a broker/dealer, we are not an investment advisor, we have no access to non-public information
                about publicly traded companies, and this is not a place for the giving or receiving of financial
                advice, advice concerning investment decisions or tax or legal advice. We are not regulated by the
                Financial Services Authority.
              </SoftTypography>

              <SoftTypography>
                We are an educational forum for analysing, learning &amp; discussing general and generic information
                related to stocks, investments and strategies. No content on the site constitutes - or should be
                understood as constituting - a recommendation to enter in any securities transactions or to engage in
                any of the investment strategies presented in our site content. We do not provide personalised
                recommendations or views as to whether a stock or investment approach is suited to the financial needs
                of a specific individual.
              </SoftTypography>

              <SoftTypography>
                Much of the content on this site is user-generated and, as such, impossible to monitor effectively.
                Excluding the BullBearVector Content and BullBearVectorData, all of the information on our Website about
                businesses, companies, investment strategies, investments and investment opportunities is provided by
                our Registered Users and other third parties. We act as a mere conduit for this information published on
                our Website, and we do not select, monitor, edit, modify review, evaluate or otherwise oversee the
                information or the publication of the information on our Website.
              </SoftTypography>

              <SoftTypography>
                Where we present investment screens, the results should only be treated as candidates for further
                research, not as a buy list or set of recommendations. Screening may help to narrow a search based on
                pre-defined criteria but it is not a substitute for independent research reflecting your individual
                criteria for investing/trading.
              </SoftTypography>

              <SoftTypography>
                BullBearVector Content and BullBearVector Data is intended to be used and must be used for informational
                purposes only. It is very important to do your own analysis before making any investment based on your
                own personal circumstances. You should take professional financial advice in connection with, or
                independently research and verify, any information that you find on our Website and wish to rely upon,
                whether for the purpose of making an investment decision or otherwise. Any arrangements between you and
                any third party contacted via the Website are at your sole risk.
              </SoftTypography>

              <SoftTypography>
                Accordingly, we will not be liable, whether in contract, tort (including negligence) or otherwise, in
                respect of any damage, expense or other loss you may suffer arising out of such information or any
                reliance you may place upon such information.
              </SoftTypography>

              <SoftTypography>
                Nothing on this Website or any part thereof is intended to constitute an offer or solicitation to buy or
                sell investments in any jurisdiction.
              </SoftTypography>

              <SoftTypography>
                We do not therefore warrant that our Website complies with the applicable laws or regulations of any
                particular jurisdiction outside Singapore. Accordingly, if it is prohibited to make information provided
                on this Website or any part thereof available in your jurisdiction or to you (by reason of nationality,
                residence or otherwise) the Website or any part thereof is not directed at you.
              </SoftTypography>

              <SoftTypography>
                We do not accept any liability for any costs, losses or damages resulting from, or related to, the
                availability or content of the Website to persons in jurisdictions outside Singapore or to persons who
                are nominees of or trustees for citizens, resident or nationals of other countries.
              </SoftTypography>

              <SoftTypography>
                We would like to draw your attention to the following important investment warnings: i) the value of
                shares and investments and the income derived from them can go down as well as up; ii) investors may not
                get back the amount they invested; and iii) past performance is not necessarily a guide to future
                performance.
              </SoftTypography>

              <SoftTypography>
                <strong>(9) General disclaimer</strong>
                <br />
                Our liability is limited and excluded to the maximum extent permitted under applicable law. We will not
                be liable for any direct or indirect loss or damage arising under these Terms, your Use of the
                Subscription Service or in connection with the Website, whether arising in tort, contract, or otherwise.
              </SoftTypography>

              <SoftTypography>
                Without limiting the generality of the exclusion of liability above, we will not be liable for any loss
                of profit, contracts, business, goodwill, data, income, revenue or anticipated savings arising under
                these Terms, your Use of the Subscription Service or in connection with the Website, whether direct or
                indirect, and whether arising in tort, contract, or otherwise; nor will we be liable for any loss or
                damage arising out of any event that is beyond our reasonable control.
              </SoftTypography>

              <SoftTypography>
                <strong>(10) Third party websites</strong>
                <br />
                The Website includes links to other websites. These links are not recommendations, and are provided for
                your information only. We have no control over the contents of those websites, and accept no
                responsibility for them or for any loss or damage that may arise from your use of them.
              </SoftTypography>

              <SoftTypography>
                <strong>(11) Trade marks</strong>
                <br />
                BullBearVector and our logo are trademarks belonging to us. We give no permission for the use of these
                trademarks, and such use may constitute an infringement of our rights. The other registered and
                unregistered trademarks or service marks on the Website are the property of their respective owners.
                Unless stated otherwise, we do not endorse and are not affiliated with any of the holders of any such
                rights and as such we cannot grant any licence to exercise such rights.
              </SoftTypography>

              <SoftTypography>
                <strong>(12) Term &amp; Termination</strong>
                <br />
                Without prejudice to our other rights under these Terms, if you (including for the avoidance of doubt
                Registered Users and Subscribers) breach any of these Terms in any way, or if we reasonably suspect that
                you have breached any of these Terms in any way, we may: (a) delete, move or edit any of your User
                Content:
              </SoftTypography>

              <SoftTypography>
                (b) send you one or more formal warnings;
                <br />
                (c) temporarily suspend your access to the Website and/or the Subscription Service;
                <br />
                (d) delete your account;
                <br />
                (e) permanently prohibit you from using the Website and/or the Subscription Service;
                <br />
                (f) block computers using your IP address from accessing the Website;
                <br />
                (g) contact your internet services provider and request that they block your access to the Website;
                and/or
                <br />
                (h) bring court proceeding against you for breach of contract or otherwise.
              </SoftTypography>

              <SoftTypography>
                Where we suspend or prohibit or block your access to the Website, part of the Website, and/or the
                Subscription Service, you must not take any action to circumvent such suspension or prohibition or block
                (including without limitation using a different account).
              </SoftTypography>

              <SoftTypography>
                <strong>(13) Subscription Trial Period</strong>
                <br />
                The duration of any Trial Period shall be as specified on the Website. Use of the Subscription Service
                shall be free of charge during the Trial Period.
              </SoftTypography>

              <SoftTypography>
                Unless you provide BullBearVector with notice to terminate the Subscription Service prior to the end of
                the Trial Period (by unsubscribing on the Website), the Charges provisions shall apply and govern your
                ongoing Use of the Subscription Service.
              </SoftTypography>

              <SoftTypography>
                After the Trial Period expires you shall be liable to pay the Charges. You accept that by providing your
                PayPal account or your credit or debit card details you authorise BullBearVector to deduct the Charges
                (or instalments of the Charges) using such payment method (as applicable) on a regular basis and in
                advance until the you terminate or cancel your subscription to the Subscription Service.
              </SoftTypography>

              <SoftTypography>
                The amount of the Charges shall be as displayed on the Website and may change from time to time.
                However, where we bill you for any upgrade modules, we will only do so based on your request for these
                modules and with your consent to the proposed upgrade pricing.
              </SoftTypography>

              <SoftTypography>
                You may only have one Trial Period. Should we identify that you have already made use of a Free Trial
                Period with the Subscription Service, you will immediately be billed for the Charges.
              </SoftTypography>

              <SoftTypography>
                <strong>(14) Charges</strong>
                <br />
                Subject to the Trial Period provisions above, in consideration for the provision of the Subscription
                Service, Subscribers agree to pay the Charges applicable to the Data plan which they have selected as
                detailed on the Website and updated from time to time. Without prejudice to its rights to recover the
                sums outstanding from the Subscriber, should BullBearVector not be able to withdraw any part of the
                Charges from the Subscriber&rsquo;s PayPal account or credit or debit card, BullBearVector reserves the
                right to:
                <br />
                suspend access to the Subscription Service; or
                <br />
                terminate this agreement to access the Subscription Service.
              </SoftTypography>

              <SoftTypography>
                <strong>(15) Refund / Cancellation</strong>
                <br />
                At the end of each subscription period, a subscription will continue to automatically renew at the
                prevailing fee rate applicable to the Data plan which has been selected by the Subscriber, unless
                terminated by us or until the Subscriber notifies us of their decision to cancel their subscription to
                the Services.
              </SoftTypography>

              <SoftTypography>
                Either party may terminate this agreement to access the Subscription Service, which in the case of the
                Subscriber may be communicated to BullBearVector by the Subscriber unsubscribing on the Website. If the
                Subscriber terminates this agreement to access the Subscription Service, the Subscriber shall ensure
                that it pays BullBearVector all Charges owing up until the date of termination (including any
                outstanding interest) and will be entitled to use the service until the end of that billing period. The
                Subscriber shall not be entitled to any refund of charges it has already paid to BullBearVector.
              </SoftTypography>

              <SoftTypography>
                <strong>Monthly Subscriptions</strong>
                <br />
                When cancelling a monthly subscription, all future charges associated with future months of your
                subscription will be cancelled. You may notify us of your intent to cancel at any time; your
                cancellation will become effective at the end of your current monthly billing period. You will not
                receive a refund; however your subscription access and/or delivery and accompanying subscriber benefits
                will continue for the remainder of the current monthly billing period.
              </SoftTypography>

              <SoftTypography>
                <strong>Annual Subscriptions</strong>
                <br />
                When cancelling an annual subscription, all future charges associated with future years of your
                subscription will be cancelled. You may notify us of your intent to cancel at any time; your
                cancellation will become effective at the end of your current annual billing period. You will not
                receive a refund, prorated or otherwise, for the remainder of the annual term. However, your
                subscription access and/or delivery and accompanying subscriber benefits will continue for the remainder
                of the current annual billing period.
              </SoftTypography>

              <SoftTypography>
                <strong>(16) General</strong>
                <br />
                If any provision of these Terms is held invalid or unenforceable by a court of competent jurisdiction,
                the remaining provisions of these Terms will remain in full force and effect, and any such invalid or
                unenforceable provisions will be deemed omitted. No waiver of any provision of these Terms by us,
                whether by conduct or otherwise, in any one or more instances, will be deemed to be, or be construed as,
                a further or continuing waiver of that provision or any other provision of these Terms.These Terms are
                for the benefit of us and our users and are not intended to benefit, or be enforceable by, any other
                person. Any termination, rescission, amendment, variation, waiver or settlement under these Terms will
                not be subject to the consent of any third party.
              </SoftTypography>

              <SoftTypography>
                User Content posted on the Website may be retained by us either on-line or archived for a period of ten
                years. You may not assign, charge, sub-contract or otherwise transfer any of your rights or obligations
                arising under these Terms. Any attempt by you to do so will be null and void. We may assign, charge,
                sub-contract or otherwise transfer these Terms, or any of our rights or obligations arising under these
                Terms, at any time. We may vary these Terms from time-to-time by posting a new version of the Terms on
                the Website. If you are a Registered User or Subscriber, we may also give you notice of the variation.
                Your continued use of the Website after a variation will constitute your acceptance of the variation.
              </SoftTypography>

              <SoftTypography>
                These Terms constitutes the entire agreement between you and us in relation to your use of the Website,
                and supersede all previous agreements in respect of your use of the Website. These Terms will be
                governed by and construed in accordance with English law, and the English courts will have (subject to
                the following) exclusive jurisdiction to adjudicate any disputes arising out of or relating to these
                Terms. Both you and we irrevocably agree for the benefit of the other to settle any dispute which may
                arise out of, under, or in connection with these Terms or the legal relationship established by them,
                and for those purposes we both irrevocably submit all disputes to the jurisdiction of the English
                courts. For the exclusive benefit of BullBearVector, BullBearVector retains the right to bring
                proceedings as to the substance of the matter in the courts of the country of your residence or, where
                these Terms are, subject to the financial disclaimer in clause 8 above, entered into in the course of
                your trade or profession, the country of your principal place of business.
              </SoftTypography>

              <SoftTypography>
                <strong>(17) Conduct, website behaviour and the support service</strong>
                <br />
                When interacting with any staff or Registered user at BullBearVector (whether online or offline in their
                professional capacity), you agree to treat them with reasonableness, courtesy, professionalism and
                respect, while avoiding the use of aggressive, demeaning, hostile, aggravating, upsetting, intimidating
                or uncivil language, as determined by us and in our absolute discretion. This is without prejudice to
                your ability to disagree and express a contrary opinion to someone else, provided such expression
                complies with the rules above. We reserve the right to terminate your Account or Subscription Services
                with us if we judge that your behaviour has fallen below these standards. In the event we exercise this
                power, you can submit an appeal to us at support@bullbearvector.com, which will be considered by our
                Support Committee, whose determination shall be absolute and final on the matter and not subject to
                review by any court or tribunal. BullBearVector is a DIY investment platform. We are not authorised or
                able to give financial advice or answer questions which in our judgment constitute doing so. Users are
                encouraged to consult our Learn Guide to answer common questions they have. Where an answer is not
                provided or unclear, Users are encouraged to contact us for clarification or assistance, and we will
                endeavour to answer any question in good faith. Nonetheless, where a User or Subscriber is making
                excessive requests to our support team, and in our judgment is incurring an disproportionate support
                cost, we reserve the right to limit the number of responses we provide in a given period. In cases where
                multiple support queries are raised in bad faith (as judged by us, and includes, but is not limited to,
                vexatious behaviour; pedantic comments; unreasonable requests; queries or comments designed to agitate
                or that have the effect of upsetting stuff not unreasonably; questions or comments where the User has no
                intention of becoming a Subscriber; auto-generated or comments or questions which are judged to be
                spam), we reserve the right to terminate the User or Subscriber&rsquo;s account, in our absolute
                discretion.
              </SoftTypography>

              <SoftTypography>
                <strong>(18) Information</strong>
                <br />
                The Website is owned and operated by Core Biz Holdings Pte. Ltd. Our registered office address is at 22
                Sin Ming Ln, #06-76 Midview City, Singapore 573969. If you wish to contact us, please email us via
                support@bullbearvector.com, or write to us at this address.
              </SoftTypography>

              <SoftTypography>
                You should print a copy of these Terms for future reference. We will not file a copy of these Terms
                specifically in relation to you, and they may not be accessible on the Website in future. These Terms
                are available in the English language only.
              </SoftTypography>
            </SoftBox>
          </div>
        </Popup>
      ) : (
        <div></div>
      )}
    </Grid>
  );
};

//we have to provide the hooks inputText and setInputText
export const SearchSymbolInput = ({ inputText, setInputText, goToFundamental, withIcon = true }) => {
  const navigate = useNavigate();
  const [symbolObject, setSymbolObject] = useState([]);
  const [isOpen, setOpen] = useState(false);
  const [isError, setError] = useState(false);
  const handleSymbolData = async (symbol) => {
    // console.log(symbol)
    let fetchedObject = await getTickerList(symbol);
    // console.log(fetchedObject)
    if (fetchedObject.data.length) {
      setError(false);
      setSymbolObject(fetchedObject.data);
    } else {
      setSymbolObject([]);
      setError(true);
    }
  };

  const handleOk = () => {
    setError(false);
    setOpen(false);
  };

  const handleStockChange = (event) => {
    // console.log("hi")
    const name = event.target.name;
    const value = event.target.value;
    setInputText((prevValue) => {
      if (value === "") {
        setSymbolObject([]);
        setOpen(false);
      } else {
        handleSymbolData(value);
        setOpen(true);
      }

      return { [name]: value };
    });
  };

  const closeStock = (event) => {
    // console.log(event)
    const symbol = event.symbol;
    const name = event.name;
    // const name = event.target.getAttribute('value');
    if (symbol !== "") {
      setInputText({ ...inputText, symbol: symbol, name: name });
    }
    setOpen(false);
    if (goToFundamental) {
      setInputText({ ...inputText, symbol: "" });
      navigate(`/dashboard/GEM/stocks-screener/${symbol}`);
    }
  };

  return (
    <div>
      <SoftInput
        name="symbol"
        icon={{ component: withIcon ? "search" : "", direction: "left" }}
        onChange={handleStockChange}
        value={inputText.symbol}
        autoComplete="off"
        type="text"
        placeholder="Search for Symbol"
        className="underlinedInput"
      />
      {isOpen ? (
        <div style={{ position: "absolute" }}>
          <List className="stockList" style={{ borderRadius: "8px" }}>
            {!isError ? (
              symbolObject.map((symbolInfo, index) => {
                return (
                  <ListItem
                    key={index}
                    value={symbolInfo.symbol}
                    onClick={() => {
                      closeStock(symbolInfo);
                    }}
                    className="stockListItems"
                  >
                    <p value={symbolInfo.symbol}>
                      {symbolInfo.name} ({symbolInfo.symbol}){" "}
                    </p>
                  </ListItem>
                );
              })
            ) : (
              <div>
                <ListItem>
                  <p style={{ textAlign: "center" }}>
                    This stock is not available. <br></br> Please Choose Another Stock!
                  </p>
                </ListItem>
                <ListItem style={{ display: "flex", justifyContent: "center" }}>
                  <SoftButton className="okButton" size="small" style={{ marginTop: "10px" }} onClick={handleOk}>
                    Ok
                  </SoftButton>
                </ListItem>
              </div>
            )}
          </List>
        </div>
      ) : (
        <div></div>
      )}
    </div>
  );
};

const determinePutOrCall = (optionCall) => {
  if (["BUY CALL", "SELL CALL", "BULL CALL SPREAD", "BEAR CALL SPREAD"].includes(upperCase(optionCall))) {
    return "call";
  }
  return "put";
};

//parameters required:
export const DateOfExpiryDropdown = ({
  underlying,
  putOrCall,
  currentDOE,
  setDOE,
  setStrikeList,
  inputText,
  setInputText,
}) => {
  const [isOpen, setOpen] = useState(false);
  const [expiryList, setExpiry] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [dateError, setDateError] = useState(false);

  const closeExpiry = (expiry) => {
    setOpen(false);
    setDOE(expiry);
    let name = "dateToExpiry";
    setInputText({ ...inputText, [name]: expiry });
    const foundItem = expiryList.find((expiryItem) => expiryItem.expirationDate === expiry);
    const strikeList = foundItem["strikePrice"];
    setStrikeList(strikeList);
  };

  const handleOk = () => {
    setOpen(false);
    setDateError(false);
  };

  const handleClick = async () => {
    if (putOrCall && underlying) {
      setLoading(true);
      setOpen(!isOpen);
      const getExpiry = await getOptionCallData(underlying, determinePutOrCall(putOrCall));
      if (getExpiry !== null) {
        setExpiry(getExpiry);
      } else {
        setDateError(true);
      }

      setLoading(false);
    } else {
      setErrorMessage("Please choose an option type");
      console.log("set error messageconso");
    }
  };

  return (
    <div>
      <div className="buttonInputBox">
        <SoftButton
          id="stock-button"
          className="portfolioDropdown dateOfExpiryButton"
          aria-haspopup="true"
          onClick={handleClick}
          variant="text"
        >
          {currentDOE}
          {isOpen ? <CloseIcon></CloseIcon> : <ExpandMoreIcon></ExpandMoreIcon>}
        </SoftButton>
      </div>

      {isOpen ? (
        <div style={{ position: "absolute" }}>
          <List className="stockList" style={{ borderRadius: "8px" }}>
            {!loading ? (
              !dateError ? (
                expiryList.map((expiryInfo, index) => {
                  return (
                    <ListItem
                      key={index}
                      className="stockListItems"
                      onClick={() => {
                        closeExpiry(expiryInfo.expirationDate);
                      }}
                    >
                      <p>{expiryInfo.expirationDate}</p>
                    </ListItem>
                  );
                })
              ) : (
                <div>
                  <p>
                    This stock is not available. <br></br> Please Choose Another Stock!
                  </p>{" "}
                  <SoftButton className="okButton" size="small" style={{ marginTop: "10px" }} onClick={handleOk}>
                    Ok
                  </SoftButton>
                </div>
              )
            ) : (
              <div className="loadingIcon">
                <CircularProgress />
              </div>
            )}
          </List>
        </div>
      ) : (
        <div></div>
      )}
    </div>
  );
};

export const StrikeDropdown = ({
  name,
  currentStrike,
  setStrike,
  inputText,
  strikeList,
  setInputText,
  setStrikeErrorMessage,
}) => {
  const [isOpen, setOpen] = useState(false);
  const calculateBuyingPower = (currentInput, name, value) => {
    let strike_1 = inputText.strike_1;
    let strike_2 = inputText.strike_2;
    let premiumPerQty = inputText.premiumPerQty;
    let quantity = inputText.quantity;

    if (strike_1 === "N.A." || strike_2 === "N.A.") {
      return "";
    }
    if (premiumPerQty === "" || quantity === "") {
      return "";
    }
    if (name === "strike_1") {
      strike_1 = value;
    } else if (name === "strike_2") {
      strike_2 = value;
    } else if (name === "premiumPerQty") {
      premiumPerQty = value;
    } else if (name === "quantity") {
      quantity = value;
    }
    if (currentInput === "Bear Call Spread") {
      return ((strike_2 - strike_1) * 100 - premiumPerQty) * quantity;
    }
    return ((strike_1 - strike_2) * 100 - premiumPerQty) * quantity;
  };

  const closeStrike = (expiry) => {
    if (inputText.optionType === "Bear Call Spread") {
      if (name === "strike_2") {
        if (inputText.strike_1 !== "N.A." && expiry < inputText.strike_1) {
          setStrikeErrorMessage("Strike 2 cannot be lower than Strike 1 for BCS");
          return;
        }
      }
      if (name === "strike_1") {
        if (inputText.strike_2 !== "N.A." && expiry > inputText.strike_2) {
          setStrikeErrorMessage("Strike 1 cannot be higher than Strike 2 for BCS");
          return;
        }
      }
      setInputText({
        ...inputText,
        buyingPower: calculateBuyingPower("Bear Call Spread", name, expiry),
        [name]: expiry,
      });
      // return;
    } else if (inputText.optionType === "Bull Put Spread") {
      if (name === "strike_2") {
        if (inputText.strike_1 !== "N.A." && expiry > inputText.strike_1) {
          setStrikeErrorMessage("Strike 2 cannot be higher than Strike 1 for BPS");
          return;
        }
      }
      if (name === "strike_1") {
        if (inputText.strike_2 !== "N.A." && expiry < inputText.strike_2) {
          setStrikeErrorMessage("Strike 1 cannot be lower than Strike 2 for BPS");
          return;
        }
      }
      setInputText({
        ...inputText,
        buyingPower: calculateBuyingPower("Bull Put Spread", name, expiry),
        [name]: expiry,
      });
    } else {
      setInputText({ ...inputText, [name]: expiry });
    }

    setStrikeErrorMessage("");
    setOpen(false);
    setStrike(expiry);

    console.log(inputText);
  };

  const handleClick = async (event) => {
    if (strikeList) {
      setOpen(!isOpen);
    } else {
      console.log("show strike error");
    }
  };

  return (
    <div>
      <div className="buttonInputBox">
        <SoftButton
          id="stock-button"
          className="portfolioDropdown dateOfExpiryButton"
          aria-haspopup="true"
          onClick={handleClick}
          variant="text"
        >
          {currentStrike}
          {isOpen ? <CloseIcon></CloseIcon> : <ExpandMoreIcon></ExpandMoreIcon>}
        </SoftButton>
      </div>
      {isOpen ? (
        <div style={{ position: "absolute" }}>
          <List className="stockList" style={{ borderRadius: "8px" }}>
            {strikeList.map((expiryInfo, index) => {
              return (
                <ListItem
                  key={index}
                  className="stockListItems"
                  onClick={() => {
                    closeStrike(expiryInfo);
                  }}
                >
                  <p>{expiryInfo}</p>
                </ListItem>
              );
            })}
          </List>
        </div>
      ) : (
        <div></div>
      )}
    </div>
  );
};

export const TableRemarks = ({ rowIndex, modifyTable, data, type }) => {
  const [inputText, setInputText] = useState(data[rowIndex]);
  const [isDisplay, setDisplay] = useState(true);
  const handleRemarksChange = (event) => {
    const value = event.target.value;
    setInputText((prevValue) => {
      return { ...prevValue, remarks: value };
    });
  };

  return (
    <div>
      {isDisplay ? (
        <div style={{ display: "flex", alignItems: "center" }}>
          {inputText["remarks"] ? <p>{inputText["remarks"]}</p> : <p>none</p>}
          <EditIcon
            onClick={() => {
              setDisplay(false);
              console.log("edit pressed");
              console.log(inputText);
            }}
            className="icon"
            style={{ marginLeft: "6px" }}
          />
        </div>
      ) : (
        <div>
          <input
            className="underlinedInput"
            value={inputText["remarks"]}
            placeholder="Type here"
            onChange={handleRemarksChange}
          />

          <div>
            <CloseIcon
              className="icon"
              style={{ marginRight: "5px" }}
              onClick={() => {
                setInputText(data[rowIndex]);
                setDisplay(true);
              }}
            />
            <DoneIcon
              className="icon"
              onClick={() => {
                const stockItemID = inputText["id"];
                const newRemarks = inputText["remarks"];
                updateStockData("remarks", stockItemID, newRemarks, type);
                modifyTable();
                setDisplay(true);
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export const ActionDropdown = ({ data, currentAction, rowIndex, modifyTable, type, onChange }) => {
  const [actionType, setActionType] = useState(null);
  const openAction = Boolean(actionType);
  const setAction = async (event, index) => {
    const action = event.target.textContent;
    if (action) {
      const rowToModify = data[rowIndex];

      // show the popup to close

      //const itemID = rowToModify["id"];
      // const response = await updateStockData("action", itemID, action, type);
      // if (response === "success") {
      // 	let newRow = { ...rowToModify, action: action };
      // 	modifyTable();
      // }
    }
    setActionType(null);

    if (onChange) onChange(action.toLowerCase(), data[rowIndex]);
  };
  const handleClick = (event) => {
    setActionType(event.currentTarget);
  };

  return (
    <div>
      <p
        className="helvetica portfolioCellText action-button"
        style={{ display: "flex", alignItems: "center" }}
        onClick={handleClick}
      >
        {currentAction ?? "Hold"}
        <ExpandMoreIcon></ExpandMoreIcon>
      </p>
      <Menu
        anchorEl={actionType}
        open={openAction}
        onClose={setAction}
        style={{ position: "", zIndex: "10000" }}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <MenuItem onClick={(event) => setAction(event, rowIndex)}>Hold</MenuItem>
        <MenuItem onClick={(event) => setAction(event, rowIndex)}>Close</MenuItem>
      </Menu>
    </div>
  );
};

export const NewsTable = ({ category, data }) => {
  let numNews = data.length;

  const trimmedWord = (word) => {
    const maxLength = 117;
    var trimmedString = word.substr(0, maxLength);
    trimmedString = trimmedString.substr(0, Math.min(trimmedString.length, trimmedString.lastIndexOf(" "))) + "....";
    return trimmedString;
  };

  return (
    <div style={{ height: "100%", maxHeight: "390px", overflowY: "" }}>
      <div
        style={
          numNews > 3
            ? {
                height: "100%",
                overflowY: "auto",
                textAlign: "left",
                marginLeft: "15px",
                marginTop: "15px",
              }
            : {}
        }
      >
        {numNews < 1 ? (
          <div>
            <p>No news</p>
          </div>
        ) : (
          data.map((row, key) => {
            let date = new Date(row.datetime * 1000);
            return (
              <div key={key}>
                <p className="roboto" style={{ fontSize: "16px", color: "#2D3748" }}>
                  {" "}
                  {row.headline}{" "}
                </p>
                <p className="roboto_medium" style={{ fontSize: "12px", color: "#718096" }}>
                  {date.toDateString()}
                </p>
                <p className="" style={{ fontSize: "14px" }}>
                  {trimmedWord(row.summary)}{" "}
                </p>
                <a
                  target="blank"
                  href={row.url}
                  className="helvetica anchorNews"
                  style={{ fontSize: "14px", float: "right", paddingRight: "5px" }}
                >
                  Read More
                </a>
                <br></br>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

export const RedBox = ({ Header }) => {
  return (
    <SoftBox
      className="cardMargin bbvColour"
      borderRadius="lg"
      // mx={2}
      p={2}
      mt={2}
      mb={2}
      textAlign="center"
    >
      <SoftBox p={2} textAlign="center">
        <SoftTypography className="roboto" style={{ color: "white", fontSize: "22px" }}>
          {Header}
        </SoftTypography>
      </SoftBox>
    </SoftBox>
  );
};

export const OldPortfolioSummary = ({}) => {
  // return (<div style={{ backgroundColor: "white", borderRadius: "16px" }}>
  // <div className="portfolioHeader">
  // 	<p className="inline mmmText">Portfolio</p>
  // 	<SoftButton className="inline bbvGrey">Manage Portfolio</SoftButton>
  // </div>
  // <div className="portfolioDiv">
  // 	<img src={rocketImg} alt="wrench" />
  // 	<p
  // 		className="helvetica inline "
  // 		style={{ fontSize: "14px", paddingLeft: "15px" }}
  // 	>
  // 		Total Stocks <br></br>
  // 		<span className="portfolioAmt">250 in stock</span>{" "}
  // 	</p>
  // 	<span></span>
  // 	<ChevronRightIcon />
  // </div>
  // <div className="portfolioDiv">
  // 	<img src={wrenchImg} alt="wrench" />
  // 	<p
  // 		className="helvetica inline"
  // 		style={{ fontSize: "14px", paddingLeft: "15px" }}
  // 	>
  // 		Total Options <br></br>{" "}
  // 		<span className="portfolioAmt">250 in stock</span>
  // 	</p>
  // 	<span></span>
  // 	<ChevronRightIcon />
  // </div>
  // <div className="portfolioDiv">
  // 	<img src={cryptoImg} alt="crpyto" />
  // 	<p
  // 		className="helvetica inline"
  // 		style={{ fontSize: "14px", paddingLeft: "15px" }}
  // 	>
  // 		Total Crypto <br></br>
  // 		<span className="portfolioAmt">250 in stock</span>
  // 	</p>
  // 	<span></span>
  // 	<ChevronRightIcon />
  // </div>
  // </div>)
};
